import {create} from 'zustand';
import {UseSubmitStatusStoreProps} from './types';
import {SubmitStatusEnum} from '../../types';

export const useSubmitStatusStore = create<UseSubmitStatusStoreProps>(set => ({
	status: SubmitStatusEnum.CREATE_REQUEST,
	setStatus: status => set({status}),
	reset: () => set({status: SubmitStatusEnum.CREATE_REQUEST}),
}));
